import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-status-indicator',
    templateUrl: './status-indicator.component.html'
})
export class StatusIndicatorComponent implements OnInit {

     @Input() status: 'active' | 'error' | 'warning' = 'active';
     @Input() activeText = 'Active';
     @Input() errorText = 'Error';
     @Input() warningText = 'Warning';

     constructor() { }

     ngOnInit(): void { }
}
